module.exports = __webpack_public_path__ + "img/org.e1429f7c.png";